module.exports = __webpack_public_path__ + "static/img/part2.befcd7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/RhythmPlanet/bottom/part2/part2.jpg
// module id = E5u+
// module chunks = 0